export default {"src":"/_next/static/media/CTRN.294099da.svg","height":18,"width":18};